import {
    bexHttpClient
} from '../../clients';
import {
 GetActivityLogResponse
} from '../bexService.types';

/**
 * Service class for performing assistant instances operations.
 */
class ActivityLogService {

    /**
     * Fetches system activity logs
     * @returns {Promise<GetActivityLogResponse>} The response from the server returns list of activities.
     */
    async getActivityLog(): Promise<GetActivityLogResponse> {
        const response = await bexHttpClient.get('/admin/get-system-activities');
        return response;
    }

}

const activityLogService = new ActivityLogService();
export { activityLogService };